/*
 * @Author: cn1994
 * @Date: 2023-08-10 14:00:57
 * @LastEditors: cn1994
 * @LastEditTime: 2023-09-15 14:23:35
 * @Description: file content
 */
import { useBaseStore } from "@/stores/base";
import { useInstStore } from '@/stores/inst'
let mixin = {
  data() {
    let baseStore = useBaseStore()
    let instStore = useInstStore()
    return {
      baseStore,
      instStore,
      texts: baseStore.getTexts,
    }
  },
  computed: {
    subjectType() {
      let subject = this.instStore.subject

      let yiliao = ['dentistry']
      let qipei = ['business_school','corporate_university']
      if (qipei.includes(subject)) {
        return 'qipei'
      } else if(yiliao.includes(subject)){
        return 'yiliao'
      }
      else {
        return 'jiaoyu'
      }
    }
  },
}

export default mixin
